import { useEffect } from 'react';

import { useTracker } from '@archipro-website/tracker';
import { useVariantSelectionState } from '../context/VariantSelectionContext';

interface TrackableProduct {
    ID: number;
}

/**
 * Logs the `ViewProduct` analytics event for the current product/variant. Shared
 * by the legacy and revamp PDPs so neither loses product-view tracking. Must be
 * called inside a `VariantSelectionProvider` (reads the selected variant for
 * price/variant id).
 */
export const useTrackProductView = (product: TrackableProduct) => {
    const { selectedVariant } = useVariantSelectionState();
    const tracker = useTracker();

    const productID = product.ID;
    const variantID = selectedVariant?.ID;
    const priceData = selectedVariant?.Price;
    const price = priceData?.Amount ? (priceData.Amount / 100.0).toFixed(2) : 0;
    const currency = priceData?.Currency ?? 'NZD';

    useEffect(() => {
        tracker.log('ViewProduct', {
            url: new URL(window.location.href),
            data: {
                content_ids: productID,
                variant_id: variantID,
                content_type: 'product',
                value: price,
                currency,
            },
        });
    }, [productID, variantID, currency, tracker, price]);
};
